<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          to="/customers/create"
          small
        >
          <v-icon small>mdi-plus</v-icon>
          Create new
        </v-btn>
      </v-col>
    </v-row>

    <app-search
      :attribute_list="search_attribute"
      @setSearchParam="setSearchParam"
    />

    <app-data-table
      :list_name="'customer'"
      :header_list="headers"
      :attribute_list="attribute_list"
      :search_param="search_param"
      :url="`/customers`"
    />
  </v-container>
</template>

<script>
export default {
  name: "CustomerList",
  components: {
    AppDataTable: () => import('../../../components/AppDataTable'),
    AppSearch: () => import('../../../components/AppSearch'),
  },
  data: () => ({
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Firstname', value: 'firstname' },
      { text: 'Lastname', value: 'lastname' },
      { text: 'Display name', value: 'display_name' },
      { text: 'Phone number', value: 'phone_number' },
      { text: 'Line ID', value: 'line_id' },
      { text: 'Email', value: 'email' },
      { text: 'Active', value: 'active' },
      { text: '', value: 'actions', sortable: false }
    ],
    search_attribute: ['firstname', 'lastname', 'display_name', 'email', 'phone_number', 'line_id'],
    search_param: '',
    attribute_list: ['id', 'firstname', 'lastname', 'display_name', 'phone_number', 'line_id', 'email', 'active'],
  }),
  methods: {
    setSearchParam (val) {
      this.search_param = val
    }
  },
};
</script>
